export const localStorage = {
  getItem: <T>(key: string): T | null => {
    if (typeof window === "undefined") {
      return null;
    }
    try {
      const item = window.localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch (error) {
      console.error(`Couldn't read localStorage key "${key}":`, error);
      return null;
    }
  },

  setItem: <T>(key: string, value: T): void => {
    if (typeof window === "undefined") {
      return;
    }
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      throw new Error(`Couldn't write localStorage key "${key}":`, {
        cause: error,
      });
    }
  },

  removeItem: (key: string): void => {
    if (typeof window === "undefined") {
      return;
    }
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      throw new Error(`Coudln't remove localStorage key "${key}":`, {
        cause: error,
      });
    }
  },
};
